export const OPEN_MODAL_SYMBOL: InjectionKey<Ref<boolean>> =
  Symbol('open-modal');

export default {};
